import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Children } from 'preact/compat';
import { CitiesService } from 'src/app/services/Cities.service';
import { CountriesService } from 'src/app/services/Countries.service';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import Swal from 'sweetalert2';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import { BtnCellRendererQxMatrix } from 'src/app/btn-cell-rendererQxMatrix';
import { BtnDeleteCellRenderer } from 'src/app/btn-deletecell-renderer';
import { CheckboxRenderer } from 'src/app/CheckboxRenderer';
import { CustomDateComponent } from 'src/app/date-components/custom-date-component.component';
import { PrimeCellEditorComponent } from 'src/app/editors/prime-cell-editor.component';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';

@Component({
  selector: 'app-CitiesAndCountries',
  templateUrl: './CitiesAndCountries.component.html',
  styleUrls: ['./CitiesAndCountries.component.scss']
})
export class CitiesAndCountriesComponent implements OnInit {
  filteredModules!: any[];
  breadcrumList: any;
  citiesRes: any = [];
  countries = [];
  name: string = "";
  isActive: boolean = true;
  isDeleted: number = 0;
  createdBy: string = "";
  createdOn = new Date();
  updatedBy: String = "";
  updatedOn = new Date();
  countriesList = [];
  countryDataForm!: FormGroup;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefsCountry!: any[];
  rowDataCountry!: any[];
  rowDataCities!: any[];
  columnDefsCities!: any[];
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    frameworkComponents: {
      agDateInput: CustomDateComponent,
      primeCellEditor: PrimeCellEditorComponent,
      checkboxRenderer: CheckboxRenderer,
      btnCellRendererQxMatrix: BtnCellRendererQxMatrix,
      btnDeleteCellRenderer: BtnDeleteCellRenderer,
      // btnCellRendererActualEntry: BtnCellRendererActualEntry,
      // btnCellRenderer: BtnCellRenderer,
    },
  };
  ButtonType!: string;
  IsAccess: any;
  lang: any;
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    // this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  constructor(private CountryService: CountriesService, private fb: FormBuilder,
    private cityService: CitiesService, private toaster: ToastrService, private kpiMaster: KpimasterService,
    private usermanagementService: UserManagementService, public router: Router,
    public translater: TranslaterService,
   public translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});

    this.columnDefsCities = [
      {
        field: 'action',
        sortable: true,
        filter: true,
        width: 50,
        hide: this.IsWrite,
        headerName: 'Actions',
        // minwidth:100,
        maxwidth: 70,
        cellRenderer: 'btnCellRendererQxMatrix',
        cellRendererParams: {
          clicked(field: any) { },
        },
        cellStyle: { textAlign: 'center' },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'cityName',
        sortable: true,
        filter: true,
        headerName: 'City Name',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'countryName',
        sortable: true,
        filter: true,
        headerName: 'Country Name',
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ];
    this.columnDefsCountry = [
      {
        field: 'action',
        sortable: true,
        filter: true,
        width: 30,
        hide: this.IsWrite,

        headerName: 'Actions',
        maxwidth: 50,
        cellRenderer: 'btnCellRendererQxMatrix',
        cellRendererParams: {
          clicked(field: any) { },
        },
        cellStyle: { textAlign: 'center' },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'name',
        sortable: true,
        filter: true,
        headerName: 'Country Name',
        headerValueGetter: this.localizeHeader.bind(this)
      }
    ];
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    }, 500);
  }

  ngOnInit() {
    
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.getAllCountries();
    this.getAllCities();

    this.countryDataForm = this.fb.group({
      CId: [''],
      countryName: ['', Validators.required],
    });
    this.cityDataForm = this.fb.group({
      Id: new FormControl('', []),
      cityName: new FormControl('', [Validators.required]),
      countryName: new FormControl('', [Validators.required]),
    });
  }

  saveUpdatecity = true;
  saveUpdateCountry = true;
  panelOpenState = false;
  cityDataForm!: FormGroup
  countryPriorityformMode: boolean = true;
  IsWrite!: boolean;
  cellClickedCity(params: any): void {
    
    const col = params.colDef.field;
    this.ButtonType = '';
    if (col === 'action') {
      this.ButtonType = params.event.target.textContent;
      if (this.ButtonType === 'edit') {
        this.ButtonType = '';
        this.clickEditCity(params.data);
      } else if (this.ButtonType === 'delete') {
        this.ButtonType = '';
        this.deleteCity(params.data);
      }
    }
  }
  clickEditCity(params: any) {
    
    this.cityDataForm.get("Id")?.setValue(params.cityId);
    this.cityDataForm.get("cityName")?.setValue(params.cityName);
    this.cityDataForm.get("countryName")?.setValue(params.countryId);
    this.saveUpdatecity = false;

  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  cellClickedCountry(params: any): void {
    
    const col = params.colDef.field;
    this.ButtonType = '';
    if (col === 'action') {
      this.ButtonType = params.event.target.textContent;
      if (this.ButtonType === 'edit') {
        this.ButtonType = '';
        this.clickEditCountry(params.data);
      } else if (this.ButtonType === 'delete') {
        this.ButtonType = '';
        this.deleteCountry(params.data);
      }
    }
  }

  clickEditCountry(params: any) {
    
    this.countryDataForm.get("CId")?.setValue(params.countryId);
    this.countryDataForm.get("countryName")?.setValue(params.name);
    this.saveUpdateCountry = false;
  }
  deleteCity(params: any): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete action!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const key = {
          cityId: params.cityId,
        };
        this.cityService.deleteCity(key).subscribe(
          (res: any) => {
            Swal.fire(
              'Deleted!',
              'Your selected city has been deleted.',
              'success'
            );
            this.reset();
            this.getAllCities();
          },
          (error: any) => {
            this.toaster.error('Error', error.error.message);
          }
        );
      }
    });
  }
  deleteCountry(params: any): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete action!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const key = {
          countryId: params.countryId,
        };
        this.CountryService.deleteCountry(key).subscribe(
          (res: any) => {
            Swal.fire(
              'Deleted!',
              'Your selected Country has been deleted.',
              'success'
            );
            this.reset();
            this.getAllCountries();
          },
          (error: any) => {
            this.toaster.error('Error', error.error.message);
          }
        );
      }
    });
  }
  getAllCountries() {
    
    const data = this.CountryService.getAllCountries().subscribe(
      (data: any) => {
        this.countries = data;
        if (this.countries.length > 0) {
          this.filteredModules = this.countries.slice();
        }
      });
  }
  getAllCities() {
    
    const val = [];
    this.cityService.getAllCity().subscribe(
      (data: any) => {
        this.citiesRes = data;
      });
  }
  addCountryResponse: any;
  addNewCountry() {
    //this.saveUpdateCountry=false;
    const val = [];
    const key = {
      name: this.countryDataForm.value.countryName,
      isActive: true,
      isDeleted: false,
      createdOn: new Date(),
      createdBy: 2
    };
    val.push(key);
    const key2 = {
      data: val
    };
    this.CountryService.addNewCountry(key2).subscribe(
      (data: any) => {
        this.addCountryResponse = data.message;
        this.toaster.success('Success', this.addCountryResponse);
        this.reset();
        this.getAllCountries();
        this.saveUpdateCountry = true;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      });

  }
  updateCountry() {
    
    // const val = [];
    const key = {
      name: this.countryDataForm.value.countryName,
      isActive: true,
      isDeleted: false,
      updateOn: new Date(),
      updateBy: 2,
      countryId: this.countryDataForm.value.CId
    };
    // val.push(key);
    // const key2 = {
    //   countryId:this.countryDataForm.value.CId,
    //   data: val,
    // };
    this.CountryService.updateCountry(key).subscribe(
      (data: any) => {
        // this.addCountryResponse=data.message;
        this.toaster.success('Success', data.message);
        this.reset();
        this.getAllCountries();
        this.saveUpdateCountry = true;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      });
    // this.reset();
    // this.getAllCountries();
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
        // this.gridColumnApi.refreshHeader();
      }
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  addNewCity() {
    this.saveUpdatecity = false;
    
    const val = [];
    const key = {
      name: this.cityDataForm.value.cityName,
      country: this.cityDataForm.value.countryName,
      isActive: true,
      isDeleted: false,
      createdOn: new Date(),
      createdBy: 2
    };
    val.push(key);
    const key2 = {
      data: val
    };
    this.cityService.addNewCity(key2).subscribe(
      (data: any) => {
        // this.addCountryResponse=data.message;
        this.toaster.success('Success', data.message);
        this.resetCity();
        this.getAllCities();
        this.saveUpdatecity = true;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      });

  }
  updateCity() {
    
    //const val = [];
    const key = {
      name: this.cityDataForm.value.cityName,
      country: this.cityDataForm.value.countryName,
      isActive: true,
      isDeleted: false,
      updatedOn: new Date(),
      updatedBy: 2,
      cityId: this.cityDataForm.value.Id,
    };
    //val.push(key);
    // const key2 = {
    //   cityId:this.cityDataForm.value.Id,
    //   data: val
    // };
    this.cityService.updateCity(key).subscribe(
      (data: any) => {
        //this.addCountryResponse=data.message;
        this.toaster.success('Success', data.message);
        this.resetCity();
        this.getAllCities();
        this.saveUpdatecity = true;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      });
    // this.resetCity();
    // this.getAllCountries();
  }
  GetMenuAccess(): void {
    
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.countryDataForm.controls[controlName].hasError(errorName);
  }

  public checkErrorCity = (controlName: string, errorName: string) => {
    return this.cityDataForm.controls[controlName].hasError(errorName);
  }
  reset() {
    this.countryDataForm.get('countryName')?.reset();
    this.saveUpdateCountry = true;
  }
  resetCity() {
    this.cityDataForm.get('countryName')?.reset();
    this.cityDataForm.get('cityName')?.reset();
    this.saveUpdatecity = true;
  }
}
